// extracted by mini-css-extract-plugin
export default {"cell-wrapper":"yo3wIh5NLVjUf__5ZnbF"};